import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "next-i18next";
import { FC } from "react";
import LeadWall from "../../../../components/LeadWall";
import { LeadWallFormValue } from "../../../../components/LeadWall/LeadWallForm";
interface LeadWallBudgetFirstStepProps {
  onPrevious: VoidFunction;
  defaultValues?: Partial<LeadWallFormValue>;
  isEmbedded?: boolean;
  onSubmit: (value: LeadWallFormValue) => void;
  isLoading: boolean;
  isError: boolean;
}
const LeadWallBudgetFirstStep: FC<LeadWallBudgetFirstStepProps> = t0 => {
  const $ = _c(21);
  const {
    onPrevious,
    defaultValues,
    isEmbedded: t1,
    isLoading,
    isError,
    onSubmit
  } = t0;
  const isEmbedded = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation("budget-check");
  let t2;
  if ($[0] !== t) {
    t2 = t("lead_wall_title");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const title = t2;
  let t3;
  if ($[2] !== t) {
    t3 = t("lead_wall_list_1");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("lead_wall_list_2");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = [t3, t4];
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const listItems = t5;
  let t6;
  if ($[9] !== t) {
    t6 = t("lead_wall_description");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const description = t6;
  let t7;
  if ($[11] !== defaultValues || $[12] !== description || $[13] !== isEmbedded || $[14] !== isError || $[15] !== isLoading || $[16] !== listItems || $[17] !== onPrevious || $[18] !== onSubmit || $[19] !== title) {
    t7 = <LeadWall title={title} description={description} listItems={listItems} onSubmit={onSubmit} isError={isError} isLoading={isLoading} onPrevious={onPrevious} defaultValues={defaultValues} isEmbedded={isEmbedded} />;
    $[11] = defaultValues;
    $[12] = description;
    $[13] = isEmbedded;
    $[14] = isError;
    $[15] = isLoading;
    $[16] = listItems;
    $[17] = onPrevious;
    $[18] = onSubmit;
    $[19] = title;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default LeadWallBudgetFirstStep;